import { render, staticRenderFns } from "./debates.vue?vue&type=template&id=3ca27ccc"
import script from "./debates.vue?vue&type=script&lang=js"
export * from "./debates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports